import {IROIWidgetConfig} from "./roi-widget.props";

export interface IROIWidgetState {
    isLoading: boolean;
    contentType: ContentType;
    showConfigModal: boolean;
    tempConfigData: IROIWidgetConfig;
    configData: IROIWidgetConfig;
    roiData: IROIData | null;
    error: string | null;
}

export interface IDailyData {
    day: string;
    count: number;
    timeSaved: number;
    costSaved: number;
}

export interface IROIData {
    totalActivities: number;
    totalHoursSaved: number;
    totalCostSaved: number;
    roi: number;
    roiPercentage: string;
    totalInvestment: number;
    totalReturn: number;
    netProfit: number;
    calculationMethod: string;
    timeframe: string;
    currency: string;
    // Daily data for charts
    dailyActivities?: IDailyData[];
    // Raw response data for top automated tasks
    rawData?: {
        report?: {
            activities?: {[key: string]: any};
        };
        roiConfig?: {
            activities?: {[key: string]: {hoursPerTask: number}};
        };
    };
    // Comparison data
    comparison?: {
        enabled: boolean;
        type: "previous_period" | "same_period_last_year";
        previousData?: {
            totalHoursSaved: number;
            totalCostSaved: number;
            totalActivities: number;
            dailyActivities?: IDailyData[];
        };
        changes?: {
            hoursSavedChange: number;
            hoursSavedPercentage: string;
            costSavedChange: number;
            costSavedPercentage: string;
            activitiesChange: number;
            activitiesPercentage: string;
        };
    };
}

export enum ContentType {
    EMPTY = "EMPTY",
    DATA = "DATA",
    ERROR = "ERROR",
    LOADING = "LOADING",
}
